import { render, staticRenderFns } from "./ComposeConversationLauncher.vue?vue&type=template&id=37232cba&"
import script from "./ComposeConversationLauncher.vue?vue&type=script&lang=js&"
export * from "./ComposeConversationLauncher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports